export default {
    methods: {
        getQueryStringParameter (name, defaultTo = null) {
            try {
                return (new URL(window.location.href)).searchParams.get(name)
            } catch (e) {
                return defaultTo
            }
        },
        setQueryStringParameter (name, value) {
            try {
                const url = (new URL(window.location.href))
                if (value != null) {
                    url.searchParams.set(name, value)
                } else {
                    url.searchParams.delete(name, value)
                }

                window.history.replaceState(null, null, url)
            } catch (e) {
                // ignored
            }
        },
        setQueryStringParameters (params) {
            Object.keys(params).forEach(k => this.setQueryStringParameter(k, params[k]))
        },
        getUrlHash () {
            return window.location.hash.replace('#', '')
        }
    }
}